// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".search-tiles[data-v-040f60bd]{position:relative;margin-left:-15px;margin-right:-15px;margin-top:-10px;margin-bottom:-15px;padding:30px 15px 0;width:100%;-webkit-transition:.3s;transition:.3s}@media screen and (max-width:768px){.search-tiles[data-v-040f60bd]{padding-left:0;padding-right:0}}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
